var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighlightedPoI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.6604,
    cy: 6.79785,
    r: 5.5,
    fill: "#0030C7",
    stroke: "#8DA9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlightedPoI);
export default __webpack_public_path__ + "static/media/Highlighted PoI.28235d1512ce978b8715ee28fa1df04d.svg";
export { ForwardRef as ReactComponent };